const moduleContext = require.context("./modules", false, /\.js|\.ts$/);

const locale = {
  zh: {},
  en: {},
};

const localeKeys = Object.keys(locale);

function getModuleNameSpace(path: string) {
  const removePathRegExp = /\.\/|\.ts|\.js/g;
  return path.replace(removePathRegExp, "");
}

function initLocale() {
  moduleContext.keys().forEach((key) => {
    const namespace = getModuleNameSpace(key);

    const { default: context } = moduleContext(key);

    if (typeof context === "object") {
      for (let contextKey in context) {
        // 语言文件的结构必须为 key => value(string [])
        const contextValues: string[] = context[contextKey];

        // 语言文件的value和locale里的属性的顺序是对应的 index = 0 = zh
        contextValues.forEach((item, index) => {
          const localeItem = locale[localeKeys[index]];
          // 创建模块 无则先初始化一个空对象
          const module = localeItem[namespace]
            ? localeItem[namespace]
            : (localeItem[namespace] = {});

          module[contextKey] = item;
        });
      }
    }
  });
}

initLocale();

export default locale;
